import { lazy, Suspense } from "react";
import { Route, BrowserRouter as Router, Routes, Navigate } from "react-router-dom";
import AppLayout from "./components/layout/AppLayout";
import LoadingPage from "./components/loader";
import { ProtectedRoute } from "./middleware/authMiddleware";
import AdminLayout from "./components/layout/admin/layout";
import UserLayout from "./components/layout/user/layout";

// import Test from "./containers/test";

const Home = lazy(() => import('./containers/home'));
const Announcements = lazy(() => import('./containers/announcements'));
const Events = lazy(() => import('./containers/events'));
const About = lazy(() => import('./containers/about'));
const Principal = lazy(() => import('./containers/principal'));
const Office = lazy(() => import('./containers/office'));
const AdditionalInfo = lazy(() => import('./containers/additionalInfo'));
const AdminBodies = lazy(() => import('./containers/adminBodies'));
const Departments = lazy(() => import('./containers/departments'));
const Library = lazy(() => import('./containers/library'));
const Sports = lazy(() => import('./containers/sports'));
const BirdsOnCampus = lazy(() => import('./containers/birdsOnCampus'));
const Grivences = lazy(() => import('./containers/grievences'));
const GeneralFacilities = lazy(() => import('./containers/generalFacilities')); 
const StudentsLife = lazy(() => import('./containers/studentsLife'));
const IQAC = lazy(() => import('./containers/iqac'));
const Faculties = lazy(() => import('./containers/faculties'));
const PageNotFound = lazy(() => import('./containers/pageNotFound'));
const FYUGP = lazy(() => import('./containers/fyugp'));
const AcademicCalendar = lazy(() => import('./containers/academicCalendar'));
const IQACSubs = lazy(() => import('./containers/iqacSections/subsections'));
// const UndertakingByPrincipal = lazy(() => import('./containers/iqacSections/undertakingbyPrincipal'));
const NEP = lazy(() => import('./containers/iqacSections/nep'));
const Research = lazy(() => import('./containers/research'));
const RTI = lazy(() => import('./containers/rti'));
const InstitutionalDistinctiveness = lazy(()=> import('./containers/iqacSections/instituteDistinctiveness'))
const FeedbackSystem = lazy(() => import('./containers/feedbackSystem'));
const Profile = lazy(()=>import('./containers/facultiesSection/facultyProfile'));


const Login = lazy(() => import('./containers/admin/login'));
const UserLogin = lazy(() => import('./containers/admin/userLogin'));
const Unauthorized = lazy(() => import('./containers/admin/unautharised'));
const Dashboard = lazy(() => import('./containers/admin/dashboard'));
const UserDashboard = lazy(() => import('./containers/user/dashboard'));

const CreateUsers = lazy(() => import('./containers/admin/createUsers'));
const ManageUsers = lazy(() => import('./containers/admin/manageUsers'));
const ActivityLogs = lazy(() => import('./containers/admin/activityLogs'));
const AdminAnnouncements = lazy(() => import('./containers/admin/announcements'));
const Help = lazy(() => import('./containers/admin/help'));
const Settings = lazy(() => import('./containers/admin/Settings'));
const AdminProfile = lazy(() => import('./containers/admin/Profile'));
const UserProfile = lazy(() => import('./containers/user/Profile'));

const EditFaculty = lazy(() => import('./containers/facultiesSection/editFaculty'));

const AppRoutes = () => {
    return (
        <Router>
            <Suspense fallback={<><LoadingPage /></>}>
                <Routes>
                    <Route
                        path="/"
                        element={
                            <AppLayout>
                                <Home />
                            </AppLayout>
                        }
                    />
                    <Route
                        path="/announcements"
                        element={
                            <AppLayout>
                                <Announcements />
                            </AppLayout>
                        }
                    />
                    <Route
                        path="/campus/events"
                        element={
                            <AppLayout>
                                <Events />
                            </AppLayout>
                        }
                    />
                    <Route 
                        path="/campus/library"
                        element={
                            <AppLayout>
                                <Library />
                            </AppLayout>
                        }
                    />
                    <Route 
                        path="/facilities/library/"
                        element={<Navigate to="/campus/library" replace />}
                    />
                    <Route 
                        path="/campus/sports"
                        element={
                            <AppLayout>
                                <Sports />
                            </AppLayout>
                        }
                    />
                    <Route 
                        path="/campus/birds-on-campus"
                        element={
                            <AppLayout>
                                <BirdsOnCampus />
                            </AppLayout>
                        }
                    />
                    <Route 
                        path="/campus/general-facilities"
                        element={
                            <AppLayout>
                                <GeneralFacilities />
                            </AppLayout>
                        }
                    />
                    <Route 
                        path="/facilities/general-facilities/"
                        element={<Navigate to="/campus/general-facilities" replace />}
                    />

                    <Route
                        path="/about"
                        element={
                            <AppLayout>
                                <About />
                            </AppLayout>
                        }
                    />
                    <Route 
                    path="/management"
                    element={
                        <Navigate to="/about" replace />
                    }
                    />
                        <Route
                            path="/institute/principal"
                            element={
                                <AppLayout>
                                    <Principal />
                                </AppLayout>
                            }
                        />
                    <Route
                        path="/institute/office"
                        element={
                            <AppLayout>
                                <Office />
                            </AppLayout>
                        }
                    />
                    <Route
                        path="/institute/policy"
                        element={
                            <AppLayout>
                                <AdditionalInfo />
                            </AppLayout>
                        }
                    />
                    <Route 
                        path="/institute/admin-bodies"
                        element={
                            <AppLayout>
                                <AdminBodies />
                            </AppLayout>
                        }
                    />
                    <Route 
                        path="/admin-bodies/admin-bodies/"
                        element={
                            <Navigate to="/institute/admin-bodies" replace />
                        }
                    />
                    <Route 
                        path="/institute/faculties"
                        element={
                            <AppLayout>
                                <Faculties />
                            </AppLayout>
                        }
                    />
                    <Route 
                        path="/institute/research"
                        element={
                            <AppLayout>
                                <Research />
                            </AppLayout>
                        }
                    />
                    <Route 
                        path="/academics/FYUGP"
                        element={
                            <AppLayout>
                                <FYUGP />
                            </AppLayout>
                        }
                    />
                    <Route 
                        path="/academics/departments"
                        element={
                            <AppLayout>
                                <Departments />
                            </AppLayout>
                        }
                    />
                    <Route 
                        path="/academics/academic-calendar"
                        element={
                            <AppLayout>
                                <AcademicCalendar />
                            </AppLayout>
                        }
                    />
                    <Route
                        path="/grievances"
                        element={
                            <AppLayout>
                                <Grivences />
                            </AppLayout>
                    }
                    />
                    <Route
                        path="/grievancesscst"
                        element={
                            <Navigate to='/grievances?grievance=scst' replace />
                        }
                     />
                    <Route
                        path="/iqac"
                        element={
                            <AppLayout>
                                <IQAC />
                            </AppLayout>
                    }
                    />
                    <Route 
                        path="/iqac/feedback-system"
                        element={
                            <AppLayout>
                                <FeedbackSystem />
                            </AppLayout>
                        }
                    />
                    <Route
                        path="/iqac/subs"
                        element={
                            <AppLayout>
                                <IQACSubs />
                            </AppLayout>
                    }
                    />
                    <Route
                        path="/iqac/nep"
                        element={
                            <AppLayout>
                                <NEP />
                            </AppLayout>
                    }
                    />
                    <Route
                        path="/iqac/institutional-distinctiveness"
                        element={
                            <AppLayout>
                                <InstitutionalDistinctiveness />
                            </AppLayout>
                    }
                    />
                    <Route
                        path="/iqac/subs/ssr"
                        element={<Navigate to="/iqac/subs?id=ssr" replace />}
                    />
                    <Route
                        path="/iqac/subs/aqar"
                        element={<Navigate to="/iqac/subs?id=aqar" replace />}
                    />
                    <Route
                        path="/iqac/subs/outcomes"
                        element={<Navigate to="/iqac/subs?id=outcomes" replace />}
                    />
                    <Route 
                        path="/iqac/co-po-pso/"
                        element={<Navigate to="/iqac/subs?id=outcomes" replace />}
                    />
                    <Route
                        path="/iqac/subs/feedback"
                        element={<Navigate to="/iqac/subs?id=outcomes" replace />}
                    />
                    <Route
                        path="/iqac/subs/nirf"
                        element={<Navigate to="/iqac/subs?id=nirf" replace />}
                    />
                    <Route
                        path="/nirf"
                        element={<Navigate to="/iqac/subs?id=nirf" replace />}
                    />
                    <Route
                        path="/policies"
                        element={<Navigate to="/institute/policy?info=policy" replace />}
                    />
                    <Route 
                        path="/right-to-information"
                        element={
                            <AppLayout>
                                <RTI />
                            </AppLayout>
                        }
                    />
                    <Route 
                        path="/right-to-informationrti/"
                        element={<Navigate to="/right-to-information" replace />}
                    />
                    <Route 
                        path="*"
                        element={
                            <AppLayout>
                                <PageNotFound />
                            </AppLayout>
                        }
                    />
                    <Route 
                        path="/faculty/profile"
                        element={
                            <Profile />
                        }
                    />
                    <Route 
                        path="/admin/login"
                        element={
                            <Login />
                        }
                    />
                     <Route 
                        path="/user/login/:roleType?"
                        element={<UserLogin />}
                    />
                    <Route 
                        path="/unauthorized"
                        element={
                            <AppLayout>
                                <Unauthorized />
                            </AppLayout>
                        }
                    />
                    <Route 
                        path="/admin"
                        element={
                            <ProtectedRoute adminOnly={true}>
                                <AdminLayout />
                             </ProtectedRoute>
                        }
                    >
                        <Route index element={<Dashboard />} />
                        
                        <Route path="create-users" element={
                            <ProtectedRoute requiredPermission="create_users">
                                <CreateUsers />
                            </ProtectedRoute>
                        } />
                        
                        <Route path="manage-users" element={
                            <ProtectedRoute requiredPermission="manage_users">
                                <ManageUsers />
                            </ProtectedRoute>
                        } />
                        
                        <Route path="activity-logs" element={
                            <ProtectedRoute requiredPermission="view_logs">
                                <ActivityLogs />
                            </ProtectedRoute>
                        } />
                        <Route path="announcements" element={
                            <ProtectedRoute requiredPermission="view_logs">
                                <AdminAnnouncements />
                            </ProtectedRoute>
                        } />
                        
                        <Route 
                        path="help"
                        element={
                            <Help />
                        }
                        />

                        <Route 
                        path="settings"
                        element={
                            <ProtectedRoute adminOnly={true} >
                            <Settings />
                            </ProtectedRoute>
                        }
                        />
                        <Route 
                        path="profile"
                        element={
                            <ProtectedRoute adminOnly={true} >
                            <AdminProfile />
                            </ProtectedRoute>
                        }
                        />
                        
                    </Route>

                    <Route 
                    path="/user"
                    element={
                        <ProtectedRoute adminOnly={false} >
                        <UserLayout/>
                         </ProtectedRoute>
                    }
                     >
                        <Route index element={<UserDashboard/>} />
                        <Route 
                        path="help"
                        element={
                            <Help />
                        }
                        />

                        <Route 
                        path="settings"
                        element={
                            <ProtectedRoute adminOnly={false} >
                            <Settings />
                             </ProtectedRoute>
                        }
                        />
                        <Route 
                        path="profile"
                        element={
                            <ProtectedRoute adminOnly={false} >
                            <UserProfile />
                            </ProtectedRoute>
                        }
                        />
                    </Route>

                    {/* Handle legacy dashboard route */}
                    <Route 
                        path="/admin/dashboard"
                        element={<Navigate to="/admin" replace />}
                    />
                    <Route 
                        path="/user/dashboard"
                        element={<Navigate to="/user" replace />}
                    />
                    <Route 
                        path="/faculty/edit"
                        element={
                            <ProtectedRoute requiredPermission="edit_faculties" >
                            <EditFaculty />
                            </ProtectedRoute>
                        }
                    />

                </Routes>
            </Suspense>
        </Router>
    );
};

export default AppRoutes;
